import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { FormFieldConfig } from '../dropdown/form_field_config';
import { Language } from 'src/app/shared/entities/language';
import { UserService } from 'src/app/admin/core/services/user.service';
import { AngularEditorConfig } from '@kolkov/angular-editor';

@Component({
  selector: 'app-multilangue-formatted-text',
  templateUrl: './multilangue-formatted-text.component.html',
  styleUrls: ['./multilangue-formatted-text.component.css']
})
export class MultilangueFormattedTextComponent implements OnInit {
  @Input() config: FormFieldConfig;
  @Input() data: any;
  @Input() languages: Language[];
  typeName: any;
  @Input() public content: any;

  editMode: boolean = true;
  value: any = {};
  multilangueMap: { [key: string]: any } = {};

  constructor(public userService: UserService) { }

  EditorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: '15rem',
    minHeight: '5rem',
    placeholder: 'Enter text here...',
    translate: 'no',
    defaultParagraphSeparator: 'p',
    sanitize: false,
    defaultFontName: 'Roboto',
    fonts: [
      { class: 'arial', name: 'Arial' },
      { class: 'times-new-roman', name: 'Times New Roman' },
      { class: 'calibri', name: 'Calibri' },
      { class: 'comic-sans-ms', name: 'Comic Sans MS' },
      { class: 'poppins', name: 'Poppins' },
      { class: 'roboto', name: 'Roboto' }
    ],
    toolbarHiddenButtons: [['insertVideo']],
    customClasses: [
      {
        name: 'quote',
        class: 'quote',
      },
      {
        name: 'redText',
        class: 'redText',
      },
      {
        name: 'titleText',
        class: 'titleText',
        tag: 'h1',
      },
    ],
  };

  ngOnInit(): void {

    this.updateEditorConfig();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['config']) {
      this.config.id = '4';
      this.config = changes['config'].currentValue;
      if (this.config.value) {
        this.multilangueMap = this.config.value;
      }
      this.typeName = this.config.typeName;
      this.editMode = this.config.editMode;
      this.typeName = this.config.typeName;
      this.updateEditorConfig()
    }
  }

  updateEditorConfig() {
    this.EditorConfig.editable = this.editMode;

  }

  isLocal(local: string): boolean {
    return (
      this.languages?.find((l) => l.key === local && l.selected) !== undefined
    );
  }

}
